import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProductTitle } from '../../component-product-title';
import { mapResponsiveValue } from '../../component-themes';
import { forwardRef } from 'react';
export const ProductTeaserMiniContentInformationProductTitle = forwardRef(({ size, ...props }, ref) => (_jsx(ProductTitle, { size: mapResponsiveValue(size, (size) => (size === 'sm' ? '2xs' : 'xs')), variant: "default", ...props, ref: ref })));
ProductTeaserMiniContentInformationProductTitle.displayName =
    'ProductTeaserMiniContentInformationProductTitle';
